import { gql } from '@apollo/client';

/**
 * Paginated rows: `pageInfo` omits `totalCount` so the API skips the expensive count (selection-set driven).
 * Use CREDENTIALS_TOTAL_COUNT when you need the total row count.
 */
export const CREDENTIALS_LIST = gql`
  query credentialsList($args: CredentialsInput!) {
    credentials(args: $args) {
      pageInfo {
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          correlations {
            assetName
            assetId
          }
          userName
          passwordHash
          hashType
          cracked
          userInfo
          homeDir
          shell
          filePath
        }
      }
    }
  }
`;

/** Same `CredentialsInput` as the list; selection includes only `pageInfo { totalCount }`. */
export const CREDENTIALS_TOTAL_COUNT = gql`
  query credentialsTotalCount($args: CredentialsInput!) {
    credentials(args: $args) {
      pageInfo {
        totalCount
      }
    }
  }
`;

/** Alias of CREDENTIALS_LIST for refetchQueries and existing imports (e.g. PDF report). */
export const GET_CREDENTIALS = CREDENTIALS_LIST;
